import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import styled from '@emotion/styled';
import { alpha } from '@mui/material';

const DeactivationInfo = styled('p')(
  ({ theme }) => ({
    marginTop: 0,
    marginBottom: 0,
    fontStyle: 'italic',
    color: alpha(theme.palette.text.primary, 0.5),
  }),
  addHighContrastStyles(({ theme }) => ({
    color: theme.palette.text.primary,
  })),
);

export default DeactivationInfo;
